const prefix = 'socan-'
export const localStore = {
  makeKey: (key: string) => {
    return `${prefix}${key}`
  },
  getItem: (key: string) => {
    return localStorage.getItem(localStore.makeKey(key))
  },
  setItem: (key: string, value: string) => {
    return localStorage.setItem(localStore.makeKey(key), value)
  },
  remove: (key: string) => {
    return localStorage.removeItem(localStore.makeKey(key))
  },
  removeItem: (key: string) => {
    return localStorage.removeItem(localStore.makeKey(key))
  },
  clear: () => {
    return localStorage.clear()
  },
}

export const sessionStore = {
  makeKey: (key: string) => {
    return `${prefix}${key}`
  },
  getItem: (key: string) => {
    return sessionStorage.getItem(localStore.makeKey(key))
  },
  setItem: (key: string, value: string) => {
    return sessionStorage.setItem(localStore.makeKey(key), value)
  },
  remove: (key: string) => {
    return sessionStorage.removeItem(localStore.makeKey(key))
  },
  removeItem: (key: string) => {
    return sessionStorage.removeItem(localStore.makeKey(key))
  },
}
